import {
  useClearRefinements,
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

function BedBathRefinement() {
  //const { items, canRefine, refine } = useCurrentRefinements();
  // bedrooms
  const currentProps = useCurrentRefinements();
  const currentItems = currentProps.items;
  const refineCurrent = currentProps.refine;
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,

    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "noOfBedrooms", sortBy: ["name:asc"] });

  const propBaths = useRefinementList({
    attribute: "noOfBathrooms",
    sortBy: ["name:asc"],
  });
  const propBathsItems = propBaths.items;
  const propBathsRefine = propBaths.refine;

  const [open, setOpen] = useState(false);
  //

  //bathrooms
  const currentPropsBath = useCurrentRefinements();
  const currentItemsBath = currentPropsBath.items;
  const refineCurrentBath = currentPropsBath.refine;
  // end bath

  const arr = currentItems.find((c) => c.attribute === "noOfBedrooms");

  const arrBath = currentItemsBath.find((c) => c.attribute === "noOfBathrooms");
  // console.log(arr);

  const clearBds = useClearRefinements({
    includedAttributes: ["noOfBedrooms"],
  });
  const clearBaths = useClearRefinements({
    includedAttributes: ["noOfBathrooms"],
  });

  return (
    <>
      <DropdownMenu.Root
        open={open}
        onOpenChange={(value) => {
          if (!value) {
            setOpen(false);
          } else {
            setOpen(true);
          }
        }}
      >
        <DropdownMenu.Trigger asChild>
          <button className=" flex cursor-pointer select-none flex-row items-center space-x-1 rounded border border-gray-400 bg-white px-5 py-2 text-sm text-gray-900 lg:py-3">
            <span>Bedrooms & Bathrooms</span>
            <IoMdArrowDropdown className=" h-5 w-5 text-gray-700" />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={2}
            className=" z-20 h-auto w-auto space-y-4 rounded-md border border-gray-300 bg-white px-6 pb-6 pt-5 shadow-md"
          >
            <div className="">
              <DropdownMenu.Label className=" text-sm text-gray-600">
                Bedrooms
              </DropdownMenu.Label>
              <div className=" mt-2 flex flex-row">
                <div
                  onClick={() => {
                    clearBds.refine();
                  }}
                  className={
                    " flex flex-shrink-0 cursor-pointer items-center justify-center rounded-l-md border   px-5 py-2 font-semibold  " +
                    (arr === undefined
                      ? "border-blue-500 bg-blue-100 text-zote-secondary"
                      : "  border-gray-300")
                  }
                >
                  Any
                </div>

                {items?.map((item, index) => {
                  const exists =
                    arr?.refinements.find((el) => el.value === item.value)
                      ?.value != undefined;
                  if (item.value === "0") {
                    return (
                      <div
                        onClick={() => {
                          refineCurrent(item.value);
                          refine(item.value);
                        }}
                        key={item.value}
                        className={
                          (exists
                            ? " border border-blue-500 bg-blue-100 text-zote-secondary "
                            : "") +
                          "  flex flex-shrink-0 cursor-pointer items-center   justify-center border   px-5 py-2 font-semibold text-gray-900" +
                          (index === items.length - 1
                            ? " rounded-r-md border border-gray-300 "
                            : " border-b border-l-0 border-r-0 border-t  border-gray-300 ")
                        }
                      >
                        Studio
                      </div>
                    );
                  }
                  return (
                    <div
                      key={item.value}
                      onClick={() => {
                        refineCurrent(item.value);
                        refine(item.value);
                      }}
                      className={
                        "  flex-shrink-0 cursor-pointer items-center justify-center border      px-5 py-2 font-semibold text-gray-900" +
                        (exists
                          ? " border-blue-500 bg-blue-100 text-zote-secondary "
                          : " border-gray-300 ") +
                        (index === items.length - 1
                          ? " rounded-r-md "
                          : " border-b border-l border-r-0 border-t   ")
                      }
                    >
                      {item.value}
                    </div>
                  );
                })}

                {/* <div className="  flex-shrink-0 cursor-pointer items-center  justify-center    px-5 py-2 font-semibold text-gray-900">
                    5
                  </div> */}
              </div>
            </div>

            <div className="">
              <DropdownMenu.Label className=" text-sm text-gray-600">
                Bathrooms
              </DropdownMenu.Label>
              <div className=" mt-2 flex flex-row">
                <div
                  onClick={() => {
                    clearBaths.refine();
                  }}
                  className={
                    " flex flex-shrink-0 cursor-pointer items-center justify-center rounded-l-md border   px-5 py-2 font-semibold  " +
                    (arrBath === undefined
                      ? "border-blue-500 bg-blue-100 text-zote-secondary"
                      : "  border-gray-300")
                  }
                >
                  Any
                </div>

                {propBathsItems?.map((item, index) => {
                  const existsBath =
                    arrBath?.refinements.find((el) => el.value === item.value)
                      ?.value != undefined;

                  return (
                    <div
                      key={item.value}
                      onClick={() => {
                        refineCurrentBath(item.value);
                        propBathsRefine(item.value);
                      }}
                      className={
                        "  flex-shrink-0 cursor-pointer items-center justify-center border      px-5 py-2 font-semibold text-gray-900" +
                        (existsBath
                          ? " border-blue-500 bg-blue-100 text-zote-secondary "
                          : " border-gray-300 ") +
                        (index === propBathsItems.length - 1
                          ? " rounded-r-md "
                          : " border-b border-l border-r-0 border-t ")
                      }
                    >
                      {item.value}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="mt-4 flex flex-row justify-between">
              <span></span>
              <div className="flex flex-row items-center space-x-6">
                <span
                  className=" cursor-pointer text-sm hover:text-zote-primary"
                  onClick={() => {
                    clearBaths.refine();
                    clearBds.refine();
                    setOpen(false);
                  }}
                >
                  Clear
                </span>
                <button
                  onClick={() => {
                    // refine([
                    //   Number.isFinite(min) ? min : undefined,
                    //   Number.isFinite(max) ? max : undefined,
                    // ]);
                    setOpen(false);
                  }}
                  className=" rounded-md bg-zote-primary px-4 py-2 text-white "
                >
                  Done
                </button>
              </div>
            </div>

            <DropdownMenu.Arrow
              className="  fill-gray-200"
              width={10}
              height={5}
            />
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </>
  );
}

export default BedBathRefinement;
